import { render, staticRenderFns } from "./OrdersTab.vue?vue&type=template&id=3134ec9e&scoped=true&lang=pug"
import script from "./OrdersTab.vue?vue&type=script&lang=js"
export * from "./OrdersTab.vue?vue&type=script&lang=js"
import style0 from "./OrdersTab.vue?vue&type=style&index=0&id=3134ec9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3134ec9e",
  null
  
)

export default component.exports